import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import OnlinePaymentTransactionApi from '../generated/api/OnlinePaymentTransaction';

export default (service: Servicelayer) => ({
  ...OnlinePaymentTransactionApi(service),

  // Add custom calls here

});
